import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, AlertTriangle, BrainCircuit } from "lucide-react";

const PAGE_META = {
  "/": { title: "Mi Diario", isHome: true },
  "/tools": { title: "Herramientas" },
  "/library": { title: "Biblioteca" },
  "/journal": { title: "Diario" },
  "/support": { title: "Red de Apoyo" },
};

export default function TopAppBar() {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === "/crisis") return null;

  const meta = PAGE_META[location.pathname] || { title: "Reconectados" };
  const isHome = meta.isHome === true;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <header
      data-testid="top-app-bar"
      className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-40 bg-white/95 backdrop-blur-xl border-b border-[#E4EBE6]"
    >
      <div className="flex items-center justify-between px-4 h-14">
        {/* Left: back or brand */}
        {isHome ? (
          <button
            onClick={() => navigate("/library")}
            className="w-9 h-9 rounded-full bg-[#EEF4F1] flex items-center justify-center hover:bg-[#C8DDD5] transition-colors duration-200"
            aria-label="Biblioteca científica"
            title="Biblioteca"
          >
            <BrainCircuit size={17} className="text-[#6B9080]" strokeWidth={2} />
          </button>
        ) : (
          <button
            data-testid="back-button"
            onClick={handleBack}
            className="w-9 h-9 rounded-full bg-[#F7F9F7] hover:bg-[#EEF4F1] flex items-center justify-center transition-colors duration-200 border border-[#E4EBE6]"
            aria-label="Volver"
          >
            <ArrowLeft size={18} className="text-[#1E2F23]" strokeWidth={2} />
          </button>
        )}

        {/* Center: title */}
        <p
          className="text-base font-bold text-[#1E2F23] tracking-tight"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          {meta.title}
        </p>

        {/* Right: SOS mini button */}
        <button
          data-testid="topbar-sos-button"
          onClick={() => navigate("/crisis")}
          className="flex items-center gap-1 px-3 h-8 rounded-full bg-[#E07A5F] text-white text-xs font-bold sos-pulse hover:bg-[#D36A4F] transition-colors duration-200"
          aria-label="Modo crisis"
        >
          <AlertTriangle size={12} strokeWidth={2.5} />
          <span>SOS</span>
        </button>
      </div>
    </header>
  );
}
